/** Copyright (c) 2021 T.Rowe Price. All rights reserved. */

import Store from 'state/Store';
import {
  getAdobeData,
  getQualtricsData
} from 'state/analytics/analyticsSelectors';

/**
 * Centralized support for populating required analytics for Adobe and Qualtrics.
 */
export const updateAdobeAnalytics = () => {
  const state = Store.getState();
  const adobeData = getAdobeData(state);

  if (window && window.metricsData) {
    const { user = {}, ras = {} } = window.metricsData;

    const mD = {
      ...window.metricsData,
      user: {
        ...user,
        ...adobeData.user
      },
      ras: {
        ...ras,
        ...adobeData.ras
      }
    };
    window.metricsData = { ...mD };
  }
};

/**
 * Centralized support for populating required analytics for Qualtrics.
 */
export const updateQualtricsAnalytics = () => {
  const state = Store.getState();
  const qualtricsData = getQualtricsData(state);

  if (window && window.trpQualtrics) {
    const qD = {
      ...window.trpQualtrics,
      ...qualtricsData
    };
    window.trpQualtrics = { ...qD };
  } else {
    if (window) {
      window.trpQualtrics = { ...qualtricsData };
    }
  }
};

export const entryPageMapping = (entryPoint) => {
  let page = 'UNKNOWN';
  switch (entryPoint) {
    case '/':
    case '':
    case '/dashboard':
      page = 'DASHBOARD';
      break;
    case '/accounts':
      page = 'ACCOUNTS';
      break;
    case '/activity':
    case '/transactions':
      page = 'ACTIVITY';
      break;
    case '/statements':
      page = 'STATEMENTS';
      break;
    case '/performance':
      page = 'PERFORMANCE';
      break;
    case '/taxes':
      page = 'TAXES';
      break;
    case '/message-center':
      page = 'MESSAGE_CENTER';
      break;
    case '/profile':
      page = 'PROFILE';
      break;
  }
  return page;
};

//send nasu account type for analytics - US532015
export const sendNASUDeleteAnalytics = (accountType) => {
  if (window && window.metricsData) {
    const data = {
      ...window.metricsData,
      nasu: {
        accountType: accountType
      }
    }
    window.metricsData = { ...data };
  }
};

export default updateAdobeAnalytics;
